<app-top-alert />
<app-big-dots-spinner [loading]="initialLoading()?.loading ?? false" [fullScreen]="true" />
<app-loader />
<router-outlet />
